export const languageStringsCampaign = {
  leavingWithChanges: "Neuložili jste změny v kampani. Chcete je vrátit zpět?",
  addFirstCampaign: "Přidejte svojí první kampaň",
  setUpFirstCampaign: "Nastavte svojí první kampaň a začněte vydělávat.",
  addCampaign: "Přidat kampaň",
  addNotification: "Přidat notifikaci",
  deleteCampaign: "Vymazat kampaň?",
  preview: "Náhled",
  unnamedCampaign: "(bez názvu)",
  table: {
    name: "Jméno",
    creationDate: "Vytvořena",
    notificationCount: "Notifikace",
    status: "Vypnuto / Zapnuto",
    delete: "Vymazat",
  },
  settings: {
    all: "ZOBRAZOVAT VŠUDE",
    custom: "VLASTNÍ VÝBĚR",
    title: "Zobrazení",
    campaignName: "Název kampaně",
    setCampaign: "Nastavení kampaně",
    newCampaign: "Nová kampaň",
    whereWillCampaignBeShown: "Kde se kampaň bude zobrazovat",
    allDescription:
      "Notifikace se budou zobrazovat napříč celým Vaším webem. Pokud chcete nějaké stránky ze zobrazování notifikací vyjmout nebo naopak definovat pouze nějaké stránky, kde se notifikace této kampaně budou zobrazovat, přepněte výběr na „Vlastní výběr“.",
    url: {
      title: "odkaz na webové stránky (URL)",
      startsWith: "Začíná na",
      includes: "Obsahuje",
      equals: "Shoduje se",
    },
    includes: "Zahrnuje",
    exclude: "Vylučuje (nepovinné)",
    addCondition: "Přidat podmínku",
  },
  design: {
    title: "Zařízení",
    notificationsDesign: "Vzhled notifikací",
    designDescription:
      "Nastavení pro celou kampaň, vzhled pro konkrétní notifikaci můžete měnit v nastavení samotné notifikace.",
    computerOff:
      "Notifikace nebudou na desktopových zařízeních (PC) zobrazovány",
    mobileOff: "Notifikace nebudou na mobilních zařízeních zobrazovány",
    computer: "Zobrazit pro počítač",
    mobile: "Zobrazit pro mobil",
    position: "Pozice",
    downLeftCorner: "Dolní levý roh",
    downRightCorner: "Dolní pravý roh",
    upLeftCorner: "Horní levý roh",
    upRightCorner: "Horní pravý roh",
    down: "Dole",
    up: "Nahoře",
    animations: "Animace",
    playAnimation: "Přehrát animaci",
    animationSettings: {
      showAfter: "Notifkace se zobrazí po",
      showDelay: "Doba zobrazení",
      delayBetween: "Prodleva mezi notifikacemi",
      showSpeed: "Rychlost zobrazení",
      second: "vteřin",
      seconds: "vteřinách",
    },
  },
  notifications: {
    title: "Notifikace",
    noNotifications: "Nemáte zatím žádné notifikace",
    addNewNotification: "Přidejte notifikaci",
    addNotificationHelperText:
      "Vyberte a klikněte minimálně na jeden z 8 zobrazených boxů (typů notifikací) ",
    table: {
      type: "Typ",
      preview: "Náhled",
      status: "Vypnuto / Zapnuto",
    },
    settings: {
      customization: {
        title: "Nastavení",
      },
      displayRules: {
        title: "Pravidla zobrazení",
        text: "Text",
        notificationText: "Text notifikace",
        variant: "Varianta",
        choseVariant: "Vyberte variantu",
        days: "dní",
        h: "h",
        addKey: "Vložit API klíč",
        show: "Zobrazí",
        notificationName: "Název notifikace",
        nameNotification: "Pojmenujte notifikaci",
        repeatNotification: "Opakování notifikací",
        fillNotificationText: "Zadejte text notifikace",
        actualVisitors: {
          nameVisitors: "Pojmenujte návštěvníky",
          visitors: "návštěvníků",
          maxVisitors: "Minimální počet návštěvníků pro zobrazení",
        },
        lastOrders: {
          maxLast: "Maximálně posledních",
          maxToShow: "Minimální počet pro zobrazení je",
          whenAtLeast: "Notifikace pouze pokud je alespoň",
          ordersLast: "Objednávky za posledních",
          haveOrderedPlaceholder: "už má objednáno. A co vy?",
          showOwnOrders: "Ukázat návštěvníkům vlastní objednávky",
          notRecoginzed: 'Anonymní uživatele pojmenovat jako "Zákazník"',
          orders: "objednávek",
        },
        lastRegistrations: {
          maxLast: "Maximálně posledních",
          registrations: "registrací",
          notRecoginzed: 'Nerozpoznaná jména jako "Návštěvník"',
          registrationsLast: "Registrace za posledních",
          showOwnRegistrations: "Ukázat návštěvníkům vlastní regisrace",
          isRegistredPlaceholder: "má dokončenou registraci",
        },
        visitorSummary: {
          visitors: "Návštěvníci",
          registrations: "Registrace",
          orders: "Objednávky",
          visitors2: "návštěvníků",
          registrations2: "registrací",
          orders2: "objednávek",
          last: "za posledních",
          minNumber: "Minimální počet",
          toShow: "pro zobrazení",
        },
        individual: {
          link: "Odkaz",
          button: "Tlačítko",
          buttonName: "Pojmenujte",
          url: "Cílový odkaz na webové stránky (URL)",
          buttonAsLink: "Odkaz jako tlačítko",
          textColor: "Barva textu",
          openLinkInNewWindow: "Otevřít odkaz v novém okně",
          buttonColor: "Barva tlačítka",
          removedLinkDescription:
            "Odebrání odkazu umožní delší text notifikace.",
          tooLongTextErrorMessage: "Text přesahuje maximální délku.",
          tooltip:
            "Zadejte kompletní url odkazu včetně http://,https://. Pokud do tohoto políčka vložíte například odkaz https://www.seznam.cz, bude návštěvník stránky po kliknutí na tlačítko přesměrován na stránku https://www.seznam.cz",
        },
        webName: "Název webu",
        apiKey: "API klíč",
        heureka: {
          title: "Propojení s Heurekou",
          description:
            "Pro aktivaci této notifikace je nutný Heureka API klíč. Chcete API klíč přidat?",
          heurekaApiKey: "Heureka API klíč",
          country: "Země",
          stars: "hvězdičky",
          reviewsWithRating: "Recenze více než s",
          maxReviews: "Minimální počet recenzí pro zobrazení",
          howToAddApiKey: {
            title: "Jak přidat Heureka klíč",
            first: "V Heurece účtu v horním menu vyberte Administrace e-shopu.",
            second: "V levém menu vyberte Ověřeno zákazníky.",
            third: "Zkopírujte tajný klíč a vložte ho do API klíč pole.",
            thirdHelp:
              "Klíč je k dispozici pokud máte dostatek hodnocení a splňujete “Oveřeno zákazníky” podmínky.",
            fourth: "Zkontrolujte funkčnost napojení pomocí tlačítka “Zkontrolovat”",
          },
        },
        zbozi: {
          title: "Propojení s Zboží.cz",
          description:
            "Pro aktivaci této notifikace je nutný Zboží.cz API klíč. Chcete API klíč přidat?",
          howToAddKey: "Jak přidat Zboží.cz API klíč",
          shopId: "ID provozovny",
          storeReview: "hodnocení obchodu",
          productReview: "hodnocení produktu",
          maxReviews: "Minimální počet recenzí pro zobrazení",
          howToAddApiKey: {
            title: "Jak přidat Sklik API klíč",
            first: "Přihlaste se do svého účtu na sklik.cz a v horním menu vyberte záložku Nastavení.",
            second:
              "V levém menu vyberte možnost API klíče a klikněte na Přidat klíč.",
            third:
              "Zadejte název klíče, zkopírujte vygenerovaný refresh token a vložte ho do pole API klíč výše. Do pole ID provozovny zadejte vaše ID provozovny ze Zboží.cz.",
            thirdHelp:
              "Zboží.cz API bylo nahrazeno novým Sklik API. ID provozovny zůstává stejné – najdete ho ve svém Zboží.cz účtu v sekci Provozovna.",
            fourth: "Zkontrolujte funkčnost napojení pomocí tlačítka “Zkontrolovat”",
          },
        },
        spolehlivaRecenze: {
          title: "Propojení se spolehlivéRecenze",
          description:
            "Pro aktivaci této notifikace je nutný se přihlásit k Spolehlivým Recenzím. Chcete se přihlásit?",
          howToAddApiKey: {
            title: "Jak se přihlásit k Spolehlivé Recenze",
            first:
              "Zkopírujte shopid a heslo z Vašeho účtu u Spolehlivé Recenze.",
            second: "Vložte tyto údaje do příslušných políček výše.",
            third: "Ověřte status.",
          },
        },
        googleReviews: {
          title: "Propojení s Google recenzemi",
          apiKey: "API Klíč",
          searchPlace: "Vyhledejte svůj podnik na Google mapách",
          placeId: "Place ID",
          companyName: "Název firmy",
          description:
            "Pro zobrazení Google recenzí na vašem webu potřebujeme propojit váš podnik z Google Maps. Využijte vyhledávací pole níže pro snadné nalezení.",
          howToAddApiKey: {
            title: "Jak přidat Google Recenze",
            first:
              "Do vyhledávacího pole zadejte název vašeho podniku přesně tak, jak je uveden na Google Maps.",
            second:
              "Z nabídky výsledků vyberte váš podnik. Pole Place ID se automaticky vyplní - jedná se o jedinečný identifikátor vašeho podniku.",
            third: "Klikněte na tlačítko \"Zkontrolovat\" pro ověření funkčnosti propojení.",
          },
          maxReviews: "Minimální počet recenzí pro zobrazení",
          reviewsWithRating: "Recenze více než s",
          stars: "hvězdičky",
          noOptions: "Žádné možnosti",
        },
        trustPilot: {
          title: "Propojení s TrustPilot",
          description:
            "Pro aktivaci této notifikace je nutný TrustPilot API klíč a Business Unit ID. Chcete API klíč přidat?",
          howToAddApiKey: {
            title: "Jak přidat TrustPilot klíč",
            first: "Přihlaste se do vašeho TrustPilot Business účtu",
            second:
              "Zkopírujte název z URL. Z adresy https://trustpilot.com/review/moje-firma zkopírujte pouze část moje-firma",
            third:
              "Tento název vložte do pole výše",
          },
          minReviews: "Minimální počet recenzí pro zobrazení",
          reviewsWithRating: "Recenze více než s",
          stars: "hvězdičky",
        },
      },
      pairing: {
        title: "Napojení",
        collectData: "Zachycení dat",
        addCondition: "Přidat podmínku",
        cantEdit: "Nelze editovat",
        pairingCondition: "Pravidlo párování",
        selectedDomain: "Vybraná doména",
        pageVisitors: "Návštěvníci jednotlivých stránek",
        domainVisitors: "Souhrny návštěvníků celé domény",
        campaignCollects:
          "Kampaň bude zachytávat návštěvníky každé stránky samostatně.",
      },
      design: {
        title: "Vzhled",
        description:
          "Výchozí vzhled je nastaven pro celou kampaň, zde ho můžete upravit pro konkrétní notifikaci",
        backgroundColor: "Barva pozadí",
        textColor: "Barva textu",
        iconbackgroundColor: "Barva pozadí ikony",
        iconColor: "Barva ikony",
        roundedCorners: "Zaoblení rohů",
        icon: "Ikona",
      },
    },
    deleteModal: {
      title: "Vymazat notifikace?",
      description: "Veškerá data budou vymazána.",
    },
    lastOrders: {
      title: "Poslední objednávky",
      description: "Doporučeno pro e-shopy s 10 a více objednávkami týdně.",
      previewText1: "Josef z Košic",
      previewText2: "má dokončenou objednávku",
    },
    lastRegistrations: {
      title: "Poslední registrace",
      description: "Doporučeno pro poptávkové weby a weby sbírající kontakty.",
      previewText1: "Josef z Košic",
      previewText2: "má dokončenou registrací",
    },
    actualVisitors: {
      title: "Návštěvnost - aktuální statistiky",
      description: "Doporučeno pro weby s minimální denní návštěvností 1 000.",
      previewText1: "návštěvníků",
    },
    visitorSummary: {
      title: "Návštěvnost - souhrné statistiky",
      description: "Doporučeno pro weby s denní návštěvností pod 1 000.",
      previewText1: "návštěvníků",
      previewText2: "uživatelé",
    },
    registrationSummary: {
      title: "Registrace - souhrné statistiky",
    },
    orderSummary: {
      title: "Návštěvnost - souhrné statistiky",
    },
    heureka: {
      title: "Heuréka - recenze a hodnocení",
      description:
        "Doporučeno pro e-shopy, které mají kladné textové recenze na Heuréce",
      previewText1:
        "V porovnaní s 12 pro max oceňujem úžasnú kameru (4k videá sú top) a tiež fotografie - obrovský rozdiel a posun. Výborne makro. Rýchly a spoľahlivý telefón. Veľká spokojnosť. Farba je krásna.",
      previewText2: "doporučuje",
    },
    zbozi: {
      title: "Zboží - recenze a hodnocení",
      description:
        "Doporučeno pro e-shopy, které mají kladné textové recenze na Zboží.cz",
      previewText1:
        "V porovnaní s 12 pro max oceňujem úžasnú kameru (4k videá sú top) a tiež fotografie - obrovský rozdiel a posun. Výborne makro. Rýchly a spoľahlivý telefón. Veľká spokojnosť. Farba je krásna.",
      previewText2: "doporučuje",
    },
    individual: {
      title: "Vlastní",
      description:
        "Otextujte si notifikaci dle libosti. Skvělá notifikace pro komunikaci slevy, dopravy zdarma a dalších benefitů vašich produktů a služeb.",
      previewText1:
        "Zaregistrujte se do našeho e-shopu a získejte 5 % slevu na Váš nákup.",
      previewText2: "Získejte dárek",
    },
    shoptetLastOrders: {
      title: "Poslední objednávky pro Shoptet",
      description: "Exkluzivní notifikace pro e-shopy na platformě Shoptet.",
      timeRange: "Časové rozmezí",
      showRandom: "Zobrazovat náhodné objednávky za poslední ",
      twoMonths: "2 měsíce",
      screwdriver: "Šroubovák",
    },
    eshopRychleLastOrders: {
      title: "Poslední objednávky pro Eshop-rychle",
      description: "Exkluzivní notifikace pro e-shopy na platformě Eshop-rychle.",
      timeRange: "Časové rozmezí",
      showRandom: "Zobrazovat náhodné objednávky za poslední ",
      twoMonths: "2 měsíce",
      screwdriver: "Šroubovák",
    },
    shoptetCouponCode: {
      title: "Shoptet slevový kód",
      description: "Exkluzivní notifikace pro e-shopy na platformě Shoptet.",
      info: "Notifikace předpokládá že na platformě shoptet máte vytvořený slevový kupón o kterém zde vyplníte informace",
      code: "Slevový kód",
      saleType: "Hodnota slevy",
      saleIn: "Sleva v",
      saleOn: "Sleva na",
      wholeSale: "Celý nákup",
      sale10: "SLEVA10",
      previewText:
        'Použijte slevový kód "SLEVA10" a získejte slevu 10 % na celý nákup.',
    },
    shopifyLastOrders: {
      title: "Poslední objednávky pro Shopify",
      description: "Exkluzivní notifikace pro e-shopy na platformě Shopify.",
      timeRange: "Časové rozmezí",
      showRandom: "Zobrazovat náhodné objednávky za poslední ",
      twoMonths: "2 měsíce",
      screwdriver: "iPhone 15 Pro",
    },
    spolehlivaRecenzeShopRating: {
      title: "Spolehlivé recenze - recenze a hodnocení",
      description:
        "Doporučeno pro e-shopy, které mají kladné textové recenze na spolehliverecenze.cz",
      previewText1:
        "Nakupování na tomto e-shopu bylo úžasné. Objednávka dorazila rychle a zboží předčilo moje očekávání. Skvělý zákaznický servis, určitě nakoupím znovu!",
    },
    spolehlivaRecenzeProductRating: {
      title: "Spolehlivé recenze - recenze a hodnocení",
      description:
        "Doporučeno pro e-shopy, které mají kladné textové recenze na spolehliverecenze.cz",
      previewText1:
        "Tento produkt je naprosto fantastický! Kvalita zpracování je na vysoké úrovni, funguje přesně podle popisu a poměr cena/výkon je vynikající. Mohu jen doporučit.",
    },
    googleReviews: {
      title: "Google Recenze - recenze a hodnocení",
      description:
        "Doporučeno pro e-shopy, které mají kladné textové recenze na Google",
      previewText1:
        "V porovnání s 12 pro max oceňuji úžasnou kameru (4k videa jsou skvělá) a také fotografie - obrovský rozdíl a posun. Výborné makro. Rychlý a spolehlivý telefon. Velká spokojenost. Barva je krásná.",
      previewText2: "doporučuje",
    },
    trustPilot: {
      title: "TrustPilot - recenze a hodnocení",
      description:
        "Doporučeno pro e-shopy, které mají kladné textové recenze na TrustPilot",
      previewText1:
        "Skvělý obchod s perfektním zákaznickým servisem. Zboží dorazilo rychle a v pořádku. Komunikace byla bezproblémová a rychlá. Mohu jen doporučit, určitě znovu nakoupím.",
      previewText2: "doporučuje",
    },
  },
  branding: {
    title: "Branding",
    sizeAndForm: {
      title: "Velikost a tvar notifikace",
      classic: "Klasicka",
      small: "Nízká",
      compact: "Kompaktní",
    },
    defaultSettings: {
      title: "Základní nastavení",
      backgroundColor: "Barva pozadi",
      textColor: "Barva textu",
      backgroundOpacity: "Průhlednost pozadí",
      borderRadius: "Zaoblení rohů",
    },
    icons: {
      title: "Zobrazovat ikony",
      iconColor: "Barva ikony",
      backgroundColor: "Barva pozadi ikony",
      backgroundRadius: "Zaoblení pozadí ikony",
    },
  },
  analytics: {
    title: "Datová analytika",
    lastOrders: "Poslední objednávky",
    lastRegistrations: "Poslední registrace",
    updateData: "Aktualizovat data",
    dateAndTime: "Datum a čas",
    customerName: "Jméno zákazníka",
    customerLocation: "Poloha zákazníka",
  },
  standardSettingsModal: {
    title: "Vzhled bude nastaven do výchozího nastavení",
    description: "Veškeré Vámi provedené změny budou přepsány.",
    applyButton: "Použít výchozí nastavení",
    closeButton: "Zavřít",
  },
};
